export default "__VITE_ASSET__RWbFRDFE__"